import React from "react";
import OrPodcastWidget from "../../../components/OrPodcastWidget";

export default function PodcastWidget(props) {
  return <OrPodcastWidget {...props} />;
}
